import React from 'react';
import './Filters.css';

const Filters = ({ search, onSearchChange, status, onStatusChange, onClear }) => {
  return (
    <div className="filters">
      <div className="filter-group">
        <input
          type="text"
          className="filter-input"
          placeholder="🔍 Buscar por nome ou código..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>

      <div className="filter-group">
        <select
          className="filter-select"
          value={status}
          onChange={(e) => onStatusChange(e.target.value)}
        >
          <option value="">📊 Todos os Status</option>
          <option value="Ativo">✅ Ativo</option>
          <option value="Cortesia">🎁 Cortesia</option>
          <option value="Inadimplencia">⚠️ Inadimplência</option>
          <option value="A Instalar">🔧 A Instalar</option>
          <option value="Cancelado">❌ Cancelado</option>
        </select>
      </div>

      {(search || status) && (
        <button className="filter-clear" onClick={onClear}>
          ✕ Limpar Filtros
        </button>
      )}
    </div>
  );
};

export default Filters;

